import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=7a15a737&scoped=true"
import script from "./WidgetCard.vue?vue&type=script&lang=js"
export * from "./WidgetCard.vue?vue&type=script&lang=js"
import style0 from "./WidgetCard.vue?vue&type=style&index=0&id=7a15a737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15a737",
  null
  
)

export default component.exports